import 'instrument';

import { ThemeProvider } from '@conteg/ui';
import * as Sentry from '@sentry/react';
import App from 'app';
import { NuqsAdapter } from 'nuqs/adapters/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from 'utils/auth/auth';
import QueryClientProvider from 'utils/gql/query-client-provider';
import GlobalStyles from 'utils/styles/global-styles';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <NuqsAdapter>
        <ThemeProvider>
          <QueryClientProvider>
            <BrowserRouter>
              <AuthContextProvider>
                <App />
                <GlobalStyles />
              </AuthContextProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </ThemeProvider>
      </NuqsAdapter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
